module.exports = __webpack_public_path__ + "static/cube_of_force-60cc71529547099f619c20b513612d08.jpeg";